import client from './client';

const gkApi = {
  getCategories() {
    return client.get('/gk/categories').then(r => r.data.data);
  },

  search(query, params = {}) {
    return client.get('/gk/search', { params: { q: query, ...params } }).then(r => r.data);
  },

  getByCategory(category, params = {}) {
    return client.get(`/gk/${category}`, { params }).then(r => r.data);
  },

  getBySlug(category, slug) {
    return client.get(`/gk/${category}/${slug}`).then(r => r.data.data);
  },

  // Admin
  create(data) {
    return client.post('/gk', data).then(r => r.data.data);
  },

  update(id, data) {
    return client.put(`/gk/${id}`, data).then(r => r.data.data);
  },

  remove(id) {
    return client.delete(`/gk/${id}`).then(r => r.data);
  },

  bulkCreate(topics) {
    return client.post('/gk/bulk', { topics }).then(r => r.data);
  },

  getRandomMCQs(count = 5) {
    return client.get('/gk/random-mcqs', { params: { count } }).then(r => r.data.data);
  },

  getMcqCategories() {
    return client.get('/gk/mcq-categories').then(r => r.data);
  },

  getMcqTopics(category) {
    return client.get('/gk/mcq-topics', { params: { category } }).then(r => r.data);
  },

  getFeaturedTopics(count = 3) {
    return client.get('/gk/featured', { params: { count } }).then(r => r.data.data);
  },
};

export default gkApi;
